<template>
  <FormulateInput
    class="input-date"
    :key="value"
    type="triotecaDatepicker"
    placeholder="Selecciona una fecha"
    language="es"
    first-day-of-week="mon"
    :typeable="true"
    :format="customFormatter"
    :parser="customParser"
    :disabled-dates="disabledDates"
    v-bind="$attrs"
    :value="value"
  >
  </FormulateInput>
</template>
<script>
import { computed } from '@vue/composition-api';
import { format, parse } from 'date-fns';
import { MAXAGE } from '@/constants/age';

export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
    };
  },
  setup(props, { root }) {
    const disabledDates = computed(() => {
      return (
        root.$attrs.disabledDates ?? {
          to: oldest,
        }
      );
    });

    const youngest = computed(() => {
      var young = new Date();
      young.setFullYear(young.getFullYear() + MAXAGE);
      return young;
    });

    const oldest = computed(() => {
      const old = new Date();
      old.setFullYear(old.getFullYear() - MAXAGE);
      old.setDate(old.getDate() - 1);
      return old;
    });

    const customFormatter = (date) => {
      return format(date, 'dd/MM/yyyy');
    };

    const customParser = (date) => {
      const [day, month, year] = date.split('/');
      if (year && year.length > 3 && isAncientDate(year, month, day)) {
        const res = parse(new Date(youngest.value).getDate(), 'dd/MM/yyyy', new Date());
        return res;
      }
      return parse(date, 'dd/MM/yyyy', new Date());
    };

    const isAncientDate = (year, month, day) => {
      const old = new Date(oldest.value).getTime();
      const ancient = new Date(year, month || '01', day || '01').getTime();
      return old > ancient;
    };

    return {
      customFormatter,
      customParser,
      disabledDates,
    };
  },
};
</script>

<style lang="postcss">
@import '@sum.cumo/vue-datepicker/dist/Datepicker.css';
</style>

<style lang="postcss" scoped>
/deep/ .vdp-datepicker {
  @apply block border-hairline border-neutral-medium rounded-md hover:cursor-pointer;

  input {
    @apply w-full px-xxxs text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;
  }
}
/deep/ .vdp-datepicker__calendar {
  @apply rounded-md border-hairline border-neutral-semilight w-[18.75rem] overflow-hidden;

  .prev,
  .next {
    @apply relative;
    .default {
      @apply w-full h-full bg-center bg-no-repeat;

      background-image: url('/img/web/icons/arrow.svg');

      &::after {
        @apply border-none;
      }
    }
  }
  .prev {
    .default {
      @apply rotate-90;
    }
  }
  .next {
    .default {
      @apply -rotate-90;
    }
  }

  .picker-view {
    @apply p-micro;
  }

  .cell.day,
  .cell.month,
  .cell.year {
    @apply border-none text-neutral-darkest;

    &.muted {
      @apply text-neutral-medium;
    }
    &.today {
      @apply bg-neutral-semilight !text-neutral-medium;
    }
    &.selected {
      @apply bg-support-medium;
    }
    &.disabled {
      @apply text-neutral-semilight;
    }
    &:hover:not(.selected) {
      @apply border-none bg-support-light;
    }
  }
}
</style>